import React from "react";
import Icon from "../../assets/Icon";

function PreviewNav({config}) {
  return (
    <div className="relative w-full px-6 py-3 shadow shadow-gray-300">
      <div className="absolute left-10 top-1/2 transform -translate-y-1/2">
        {/* <Icon type="hire-logo" width="100" height="45" /> */}
        {config?.whiteLabelingRequired ? (
          <img
            alt="logo"
            src={config?.whiteLabelingLink}
            className="h-[55px] py-1"
            onError={(e) => {
              e.target.onerror = null; // Prevents infinite loop in case the fallback fails
              e.target.style.display = "none"; // Hides the broken image
              e.target.nextSibling.style.display = "block"; // Shows the default icon
            }}
          />
        ) : (
          <Icon type="hire-logo" width="100" height="45" />
        )}
      </div>
      <div className="text-right md:text-center preview-nav-title">
        <p className="font-semibold text-[1.3rem] text-[#206DC5] whitespace-nowrap">
          Analyzing Interview Preparedness
        </p>
      </div>
    </div>
  );
}

export default PreviewNav;
